import { html } from 'lit';
const MicPanel =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.25 2a3.26 3.26 0 0 0-3.26 3.26v5.76a3.26 3.26 0 0 0 6.52 0V5.26c0-1.8-1.46-3.26-3.26-3.26M7.63 9.934a.815.815 0 1 0-1.63 0v1.087a6.25 6.25 0 0 0 5.435 6.197v2.77h-1.359a.815.815 0 1 0 0 1.63h4.348a.815.815 0 0 0 0-1.63h-1.359v-2.77a6.25 6.25 0 0 0 5.435-6.197V9.934a.815.815 0 0 0-1.63 0v1.087a4.62 4.62 0 0 1-9.24 0z" clip-rule="evenodd"/>
  </svg>
`;
export default MicPanel;
